// Text-input time field that renders as HH:MM (24h). Sidesteps the
// Chromium AM/PM display on native <input type="time"> — see DateField
// for the longer rationale. Unlike date, the parent state IS the
// display value (no ISO ↔ display conversion), so this is simpler.
//
// Callers that want a hover hint wrap the whole <TimeField> in a
// <TextTooltip> at the callsite — the field itself never takes a
// native `title` attribute (CLAUDE.md forbids that route).

import { Show, type Accessor } from "solid-js";
import { TextTooltip } from "./TextTooltip";
import { sanitiseHHMM } from "./helpers";
import s from "./DateField.module.css";

export interface TimeFieldProps {
  value: Accessor<string>;          // "HH:MM" or ""
  setValue: (hhmm: string) => void;
  id?: string;
  ariaLabel?: string;
}

export function TimeField(props: TimeFieldProps) {
  function onInput(e: InputEvent & { currentTarget: HTMLInputElement }) {
    props.setValue(sanitiseHHMM(e.currentTarget.value));
  }

  return (
    <div class={s.wrap}>
      <input
        id={props.id}
        type="text"
        inputmode="numeric"
        maxlength="5"
        pattern="^([01]\d|2[0-3]):[0-5]\d$"
        placeholder="HH:MM"
        value={props.value()}
        onInput={onInput}
        aria-label={props.ariaLabel}
      />
      <Show when={props.value()}>
        <TextTooltip text="Clear" description="Reset the time field">
          <button
            type="button"
            class={s.clear}
            onClick={() => props.setValue("")}
            aria-label="Clear time"
          >×</button>
        </TextTooltip>
      </Show>
    </div>
  );
}
